import React from "react";
import PropTypes from "prop-types";

export default function PhotoInstructions({
  instructionsHeaderText,
  staffType
}) {
  /* eslint-disable max-len, react/no-unescaped-entities */
  return (
    <div className="bg-light container pt-3 pb-3">
      <h5>{instructionsHeaderText}</h5>
      <p>
        If you have a project you'd like us to work on for your department, team
        or group, please fill out the request form.
      </p>
      <p>Our {staffType} staff will reach out with any questions.</p>
      <p>
        Please note that we may not be able to fulfill all requests, however
        we'll work with you as closely as possible to make sure your needs are
        met.
      </p>
    </div>
    /* eslint-enable max-len, react/no-unescaped-entities */
  );
}

PhotoInstructions.defaultProps = {
  instructionsHeaderText: "Instructions"
};

PhotoInstructions.propTypes = {
  instructionsHeaderText: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/Shared/Instructions.js